import { makeAutoObservable } from "mobx";
import { getItemKey } from "../../stores/DataTableStore";
import { FiltersStore } from "@/stores/FiltersStore";
export class TableSelectStore {
    constructor(dataTableStore, config, filters) {
        this.visible = false;
        this.pagedData = [];
        this.loading = false;
        this.inited = false;
        this.filterStore = null;
        // Публичные методы
        /**
         * Обновляем опции при изменении выбранных строк
         * при этом опции, которые были выбраны ранее не удаляются
         * таким образом мы кэшируем опции и при переключении страниц они не удаляются
         */
        this.updatePagedData = (rowKey) => {
            const uniqOptions = Array.from(new Map([...this.pagedData, ...this.dataTableStore.data].map((item) => [
                getItemKey(item, rowKey),
                item,
            ])).values());
            this.setPagedData(uniqOptions);
        };
        this.setPagedData = (data) => {
            this.pagedData = data;
        };
        this.setLoading = (loading) => {
            this.loading = loading;
        };
        this.setVisible = (visible) => {
            this.visible = visible;
        };
        this.setInited = (inited) => {
            this.inited = inited;
        };
        this.reset = () => {
            this.dataTableStore.reset();
            this.setInited(false);
            this.filterStore?.clearAllFilters();
        };
        this.dataTableStore = dataTableStore;
        this.multiple = config.multiple || false;
        this.dataLoader = config.dataLoader;
        if (filters) {
            this.filterStore = new FiltersStore();
            this.filterStore.setFilterItems(filters);
        }
        makeAutoObservable(this);
    }
    async init() {
        try {
            this.setLoading(true);
            if (this.dataLoader) {
                const options = await this.dataLoader();
                this.setPagedData(options);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.setLoading(false);
        }
    }
}
